import React, {
  useEffect,
  useState,
} from "react";

import AppModal from "./AppModal";

const ReminderModal = ({
  show,
  setShow,
  editData,
}) => {

  const [formData, setFormData] =
    useState({
      title: "",
      date: "",
      time: "",
      priority: "",
      status: "",
      note: "",
    });

  // Edit Data Fill
  useEffect(() => {

    if (editData) {

      setFormData({
        title:
          editData.title || "",
        date:
          editData.date || "",
        time:
          editData.time || "",
        priority:
          editData.priority || "",
        status:
          editData.status || "",
        note:
          editData.note || "",
      });

    } else {

      setFormData({
        title: "",
        date: "",
        time: "",
        priority: "",
        status: "",
        note: "",
      });

    }

  }, [editData, show]);

  // Input Change
  const handleChange = (e) => {

    const { name, value } =
      e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Submit
  const handleSubmit = () => {

    console.log(formData);

    setShow(false);
  };

  return (
    <AppModal
      show={show}
      setShow={setShow}
      title={
        editData
          ? "Edit Reminder"
          : "Add Reminder"
      }
      size="modal-lg"
      footer={
        <>
          <button
            className="btn btn-danger"
            onClick={() =>
              setShow(false)
            }
          >
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            {editData
              ? "Update Reminder"
              : "Save Reminder"}
          </button>
        </>
      }
    >

      <div className="row">

        {/* Reminder Title */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Reminder Title
          </label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter reminder title"
            name="title"
            value={formData.title}
            onChange={handleChange}
          />

        </div>

        {/* Reminder Date */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Reminder Date
          </label>

          <input
            type="date"
            className="form-control"
            name="date"
            value={formData.date}
            onChange={handleChange}
          />

        </div>

        {/* Reminder Time */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Reminder Time
          </label>

          <input
            type="time"
            className="form-control"
            name="time"
            value={formData.time}
            onChange={handleChange}
          />

        </div>

        {/* Priority */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Priority
          </label>

          <select
            className="form-select"
            name="priority"
            value={formData.priority}
            onChange={handleChange}
          >
            <option value="">
              Select Priority
            </option>

            <option value="High">
              High
            </option>

            <option value="Medium">
              Medium
            </option>

            <option value="Low">
              Low
            </option>

          </select>

        </div>

        {/* Status */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Status
          </label>

          <select
            className="form-select"
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="">
              Select Status
            </option>

            <option value="Pending">
              Pending
            </option>

            <option value="Completed">
              Completed
            </option>

            <option value="Cancelled">
              Cancelled
            </option>

          </select>

        </div>

        {/* Note */}
        <div className="col-md-12 mb-3">

          <label className="form-label">
            Note
          </label>

          <textarea
            rows="4"
            className="form-control"
            placeholder="Write reminder note..."
            name="note"
            value={formData.note}
            onChange={handleChange}
          ></textarea>

        </div>

      </div>

    </AppModal>
  );
};

export default ReminderModal;